/**
 * @returns {Object}
 */
export function multiselectRequired() {

    return {
        restrict: 'A',
        require: '?ngModel',
        link: ($scope, element, attr, ctrl) => {

            const falseArray = [
                '0',
                0,
                false,
                'false'
            ];

            if (falseArray.some(x => x === attr.multiselectRequired)) {

                return;
            }

            $scope.$watch(attr.selectedModel, (model) => {

                ctrl.$setValidity('multiselectRequired', angular.isArray(model) && model.length > 0);
            }, true);
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/multiselect-required.directive.js